<script setup lang="ts">
import SharePopover from './SharePopover.vue';

defineProps<{
  showOverlay?: boolean;
}>();

defineEmits<{
  (e: 'update:activeStep', step: number): void;
}>();
</script>

<template>
  <div class="preview-stage-mock dark">
    <!-- Image Container Area -->
    <div class="share-card-frame-mock dark">
       <div class="nyc-share-card-visual dark">
          <img src="@/assets/nyc_card_final.png" alt="NYC Share Card" />
       </div>
    </div>

    <!-- Bottom Actions Bar -->
    <div class="share-controls-row dark">
      <div class="pagination-controls dark">
        <div class="p-btn dark"><i class="pi pi-chevron-left"></i></div>
        <span class="page-count">1 of 36</span>
        <div class="p-btn dark active"><i class="pi pi-chevron-right"></i></div>
      </div>
      
      <div class="action-buttons-group dark">
        <div class="share-cta-btn-mock dark" @click="$emit('update:activeStep', 2)">
           <i class="pi pi-share-alt"></i>
           <span>Share</span>
        </div>
      </div>
    </div>

    <SharePopover v-if="showOverlay" />
  </div>
</template>

<style scoped>
@import 'primeicons/primeicons.css';

.preview-stage-mock { display: flex; flex-direction: column; height: 100%; gap: 24px; position: relative; }

.share-card-frame-mock { 
  flex-grow: 1; 
  background: #000; 
  border-radius: 20px; 
  border: 1px solid rgba(255,255,255,0.1); 
  overflow: hidden; 
  display: flex; 
  align-items: center; 
  justify-content: center;
}
.nyc-share-card-visual { width: 100%; height: 100%; }
.nyc-share-card-visual img { width: 100%; height: 100%; object-fit: contain; }

.share-controls-row { display: flex; justify-content: space-between; align-items: center; padding: 0 10px; margin-top: auto; }
.pagination-controls { display: flex; align-items: center; gap: 16px; color: #fff; font-weight: 700; }
.p-btn { width: 44px; height: 44px; background: #27272a; border-radius: 8px; display: flex; align-items: center; justify-content: center; color: #a1a1aa; border: none; }
.p-btn.active { background: #e21b0d; color: #fff; }

.action-buttons-group { display: flex; gap: 12px; }
.share-cta-btn-mock { background: #e21b0d; padding: 0 24px; height: 44px; border-radius: 8px; display: flex; align-items: center; gap: 10px; color: #fff; font-weight: 800; border: none; cursor: pointer; transition: all 0.2s ease; }
.share-cta-btn-mock:hover { background: #ff2d1c; transform: translateY(-1px); }

@media (max-width: 768px) {
  .preview-stage-mock { gap: 0; }
  .share-card-frame-mock { border-radius: 0; padding: 20px; background: transparent; }
  .share-controls-row { 
    padding: 12px 16px; 
    background: #000;
    border-top: 1px solid rgba(255,255,255,0.05);
    padding-bottom: max(12px, env(safe-area-inset-bottom));
  }
  .page-count { font-size: 0.8rem; min-width: 50px; }
  .p-btn { width: 36px; height: 36px; }
  .share-cta-btn-mock { padding: 0 20px; height: 36px; font-size: 0.85rem; }
}
</style>
